/**
 * Zustand store for general UI state (toasts, contributor modal, etc.)
 */
import { create } from 'zustand';

export const useUIStore = create((set) => ({
  // ── Contributor portal ────────────────────────────────────────────────────
  isContributorPortalOpen: false,
  openContributorPortal: () => set({ isContributorPortalOpen: true }),
  closeContributorPortal: () => set({ isContributorPortalOpen: false }),

  // ── Toast notifications ───────────────────────────────────────────────────
  toasts: [],
  addToast: ({ title, description, variant = 'default', duration = 4000 }) => {
    const id = crypto.randomUUID();
    set((s) => ({ toasts: [...s.toasts, { id, title, description, variant }] }));
    setTimeout(() => {
      set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) }));
    }, duration);
  },
  removeToast: (id) =>
    set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) })),

  // ── Reset (called on logout) ──────────────────────────────────────────────
  reset: () => set({ isContributorPortalOpen: false, toasts: [] }),
}));
